"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
function memoize(input) {
    var defaultConfig = {
        cache: new Map(),
        expirationTimeMs: 1000 * 60
    };
    return function (target, propertyName, descriptor) {
        var resolvedConfig = __assign({}, defaultConfig);
        if (typeof input === 'number') {
            resolvedConfig.expirationTimeMs = input;
        }
        else {
            resolvedConfig = __assign({}, resolvedConfig, input);
        }
        if (descriptor.value != null) {
            var originalMethod_1 = descriptor.value;
            descriptor.value = function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                var key;
                var keyResolver = typeof resolvedConfig.keyResolver === 'string' ?
                    this[resolvedConfig.keyResolver].bind(this) :
                    resolvedConfig.keyResolver;
                if (keyResolver) {
                    key = keyResolver.apply(void 0, args);
                }
                else {
                    key = JSON.stringify(args);
                }
                if (!resolvedConfig.cache.has(key)) {
                    var response = originalMethod_1.apply(this, args);
                    setTimeout(function () {
                        resolvedConfig.cache.delete(key);
                    }, resolvedConfig.expirationTimeMs);
                    resolvedConfig.cache.set(key, response);
                }
                return resolvedConfig.cache.get(key);
            };
            return descriptor;
        }
        else {
            throw Error('@memoize is applicable only on a methods.');
        }
    };
}
exports.memoize = memoize;
//# sourceMappingURL=../../src/dist/memoize/memoize.js.map